import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import { getColumnNameArrayPerProcess, getProcessName, settingHideProcessShcema } from "../../lib/TkPopUtils/TkPopProductMangeDetailUtils";
import getSchema from "../../lib/api/getSchema";
import TkPopProductDetailCommonDialog from "../dialogTypes/TkPopProductDetailCommonDialog";

function TkPopProductManageDetailCommonUpdate(props) {

    const { t } = useTranslation();

    const { id, grid, refresh, onSuccess, onSelectMst, detailSeletMst, processCode, processName, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();
    const [schema, setSchema] = useState();
    // detailSeletMst?.processCode

    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema("TkPopProductManageDetail");

            if (mounted) {
                let processCodeValue = processCode;
                processCodeValue = processCode === "CAM" ? processCode : getProcessName(processCode);

                if (processName?.includes("소재인수")) {
                    processCodeValue = getProcessName("PR_START");
                }

                schema = settingHideProcessShcema(processCodeValue, schema);
                if (getProcessName(processCode) !== "Measurement" && !processName?.includes("소재인수")) {

                    schema.columns.push({
                        name: "workers",
                        formOrder: 315,
                        hideInForm: false,
                        formGroup: 0,
                        formItemType: "multipleAutocomplete",

                        codeInfo: {
                            tableName: "User",
                            nameColumn: ["fullName"],
                            valueColumn: "username",
                            useEmptyValue: false,
                            sortByName: true,
                        }
                    })
                }
                setSchema(schema);

            }

        })();

        return (() => {

            mounted = false;

        });

    }, [processCode, processName]);

    const onOpen = () => {

        if (grid) {

            let selectData = { ...(grid.selectedItems[0]) }
            let returnObj = {};
            returnObj["processCode"] = processCode;
            for (let column in selectData) {
                if (column === "workerId") {
                    let workerArray = [];
                    let workerValues = selectData[column]?.split(",");
                    let workerName = selectData["workers"]?.split(",");
                    if (workerValues) {

                        for (let [index, value] of workerValues.entries()) {
                            workerArray.push({ name: workerName[index], value: value })
                        }
                    }

                    returnObj["workers"] = workerArray;
                }

                if (column === "planDetailId" || getColumnNameArrayPerProcess(processCode === "CAM" ? processCode : getProcessName(processCode)).includes(column)) {

                    if (column === "workers") {
                        continue;
                    }

                    if (column === "workTime") {
                        let hms = selectData[column];
                        if (hms) {

                            let hmsSplit = hms.split(':');
                            var seconds = (+hmsSplit[0]) * 60 * 60 + (+hmsSplit[1]) * 60 + (+hmsSplit[2]);

                            returnObj[column] = seconds / 3600 ?? 0;
                        }
                        continue;
                    }
                    returnObj[column] = selectData[column];
                }
            }
            // console.log(returnObj)
            setFormData({ ...(returnObj) });

        }

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onUpdateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };

    return (

        <>
            <UpdateRecordButtonLayout id={id + "update-button"} onClick={onOpen} {...others} />
            {/* <AutoFormDialog
                id={id + "update-dialog"}
                mode="edit"
                formId={id + "update-form"}
                title={schema ? t(`dialog.title.${processCode === "CAM" ? processCode : id}.update`) : ""}
                schema={schema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            /> */}
            <TkPopProductDetailCommonDialog
                id={id + "create-dialog"}
                mode="update"
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${processCode === "CAM" ? processCode : id}.update`) : ""}
                schema={schema}
                initialData={formData}
                open={open}
                processCode={onSelectMst?.processCode}
                onClose={onClose}
                onSelectMst={onSelectMst}
                detailSeletMst={detailSeletMst}
                onSuccess={onUpdateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                update
            />
        </>

    );
}

export default TkPopProductManageDetailCommonUpdate;

